export default "__VITE_PUBLIC_ASSET__1021d92d__"